import PropTypes from 'prop-types';
import React from 'react';

const SlideAnimation = ({ children, duration, direction, delay, offset }) => (
  <>
    <div className="slide-animation">{children}</div>
    <style jsx>{`
      .slide-animation {
        position: relative;
        animation: slideIn ${duration}s forwards;
        animation-delay: ${delay}s;
        left: ${direction === 'left' ? offset : 'auto'};
        right: ${direction === 'right' ? offset : 'auto'};
      }
      @keyframes slideIn {
        0% {
          ${direction}:-100%;
        }
        90% {
          ${direction}:10px;
        }
        95% {
          ${direction}:-10px;
        }
        100% {
          ${direction}:0px;
        }
      }
    `}</style>
  </>
);

SlideAnimation.defaultProps = {
  delay: 0,
  direction: 'left',
  duration: 2,
  offset: '-10000px',
};

SlideAnimation.propTypes = {
  children: PropTypes.node,
  delay: PropTypes.number,
  direction: PropTypes.oneOf(['left', 'right']),
  duration: PropTypes.number,
  offset: PropTypes.string,
};

export default SlideAnimation;
